module.exports = __webpack_public_path__ + "img/nmr.2d222720.svg";